import React, { useState, useEffect, useReducer } from 'react';
//import { withRouter } from "react-router";
import _ from 'lodash'
import { Link, useParams, useNavigate } from 'react-router-dom'
import ScrollView from 'devextreme-react/scroll-view';
import Header from '../header/Header'
import Footer from '../footer/Footer'
import { postUserLog } from '../../actions/common'
import RailGrid from '../common/railGrid/RailGrid';
import Whiteboard from '../common/WhiteBoard/WhiteBoard';
import KaizenMenu from './KaizenMenu';
import KaizenAdmin from './KaizenAdminMenu'; 
import NexusCalendar from '../common/nexusCalendar/NexusCalendar';
import * as utils from '../../common/utils'
import * as actions from '../../actions/siteDetails';
import siteReducer from '../../reducers/siteDetails';
import AsyncCallHandler from '../../common/AsyncCallHandler'
import NEXUS_CONST from '../../common/constants'

const initialState = { siteLocations: [], tiers: [], userData: null, pinSiteStatus: null, pinnedSites: [] };

const SiteApps = props => {
    //const { router, match, location, routes, history } = props
    //const { category, app, site } = match.params;

    const { category, app, site } = useParams();
    const navigate = useNavigate()

    const [state, dispatch] = useReducer(siteReducer, initialState);
    const { siteLocations, pinnedSites, userData } = state
    const isEditable = userData ? utils.isEditable(userData) : null;


    const appsTxt = {
        digital: 'Digital Tier',
        standardWork: 'Standard work',
        settings: 'Settings',
        rail: 'Rail Actions',
        calendar: 'Calendar',
        whiteboard: 'Whiteboard',
        kaizen: 'Kaizen',
        kaizenAdmin: 'Admin'


    }


    var tierList = [
        { id: '', label: "All Tiers" },
        { id: '1', label: "Tier 1" },
        { id: '2', label: "Tier 2" },
        { id: '3', label: "Tier 3" },
        { id: '4', label: "Tier 4" }
    ];

    const [activeGbe, setActiveGbe] = useState('all')
    const [activeTier, setActiveTier] = useState('')
    const [searchTxt, setSearchTxt] = useState('')




    const [animate, setAnimate] = useState('animate');


    const handleTierChange = val => {
        // setActiveTier(val.id);
        postUserLog({ event: 'Select Tier', data: { action: val.label + ' selected', module: 'Tier Screen', section: 'Select Tier', siteUId: site, widget: '', } })
    }


    const navigateTo = val => {

        navigate('/' + val);
    }

    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: false,
        scrollByThumb: true,
    }

    useEffect(() => {
        actions.getUserData(dispatch, site);
        actions.fetchSiteLocations(dispatch, category);
        actions.fetchPinnedSites(dispatch, category);
        AsyncCallHandler("settings/getTierListData?siteid="+ site, NEXUS_CONST.GET)
        .then(res => {
         
         // var test =   res.data.filter(tier => tier.includes(site)).map(filteredtier => (filteredtier))
          //let list = res.data.filter(person => person.tierLevel == tierLevel && person.employeeID === employeeID && person.tierName.toLowerCase() === tierName.toLowerCase()).map(function (item) { return ({ value: item.employeeID }); })
           // var test= res.data?.map(d => { return d.title })
            //setSqdicp(test) 
        });

    }, []);

    const updatePinSite = () => {
        let site = getSitInfo();
        let isPinned = site.isPinned ? false : true;
        let pinStatus = isPinned ? 'pinned' : 'unpinned';
        actions.updatePinSite(dispatch, `siteid=${site.siteId}&pinned=${isPinned}`, category);
        postUserLog({ event: 'Pin/UnPin Site', data: { action: site.siteName + ' site ' + pinStatus, module: 'Tier Screen', section: 'Header', siteUId: site.siteId, widget: '', } })
    }
    const getSitInfo = () => {
        let data = _.find(siteLocations, ['siteId', site]);
        return data
    }

    const getSiteName = () => {

        let data = getSitInfo();
        return data ? data.siteName : '';

    }


    return (
        <>
            <Header showPinBtn={updatePinSite} site={getSitInfo()} />

            <section className="page-content">

                <div className="site-view tier-wrap">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className={"icon icon-" + utils.getSbgName(category)}></span>
                            <ul>
                                <li><Link to={`/home/${category}`} onClick={() => { postUserLog({ event: 'SBG Clicked', data: { action: 'Navigates to ' + utils.getSbgNameTxt(category) + ' Site Selection Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>{utils.getSbgNameTxt(category)}</Link></li>
                                <li><Link to={`/sitehome/${category}/${site}`} onClick={() => { postUserLog({ event: 'Site Clicked', data: { action: 'Navigates to ' + getSiteName() + ' Site Home Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>{getSiteName()}</Link></li>
                                {app == 'kaizenAdmin' && <li><Link to={`/siteApp/${category}/${site}/kaizen`} onClick={() => { postUserLog({ event: 'Site Clicked', data: { action: 'Navigates to ' + getSiteName() + ' Site Home Screen', module: 'Tier Screen', section: 'BreadCrumb', siteUId: site, widget: '', } }) }}>Kaizen</Link></li>}
                                <li>{appsTxt[app]}</li>
                            </ul>
                        </div>
                        <div className="site-head">
                            <div className="page-heading">
                                <h2><span className={"icon action"}></span> {appsTxt[app]}</h2>
                            </div>

                        </div>

                        {userData && <div className="site-body scroll">
                            <ScrollView
                                id="siteApps"
                                {...scrollConfig}
                            >
                                <div className="site-body w-100" >
                                    {app == 'whiteboard' && <Whiteboard siteId={site} widgetId={site} />}
                                    {app == 'calendar' && <div className="nexuscalendar w-100" ><NexusCalendar tierId="" isEditable={isEditable} siteId={site} /></div>}
                                </div>
                                <div className="site-body w-90">
                                    {app == 'rail' && <div className="w-100"><RailGrid tab="" tierId="" isEditable={isEditable} siteUid={site} widgetId="master"/></div>}
                                    {app == 'kaizen' && <KaizenMenu category={category} site={site} />}
                                    {app == 'kaizenAdmin' && <KaizenAdmin category={category} site={site} />}

                                </div>
                            </ScrollView>
                        </div>
                        }
                    </div>
                </div>
            </section>

            <Footer showThemeSwitch={true} hideSiteCount={true} activeSites={pinnedSites} sbg={category} />
        </>
    );
}
export default SiteApps
//export default withRouter(SiteApps)